'use client';

import { useEffect } from 'react';

import { env } from '@/env.mjs';

declare global {
    interface Window {
        dataLayer: Record<string, unknown>[];
    }
}

export const GtmProvider = () => {
    useEffect(() => {
        const GTM_ID =
            env.NEXT_PUBLIC_APP_COUNTRY === 'RO'
                ? 'GTM-NR8M2GCP'
                : 'GTM-WTLSGTW';

        if (document.getElementById('gtm-script')) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        });

        const inlineScript = document.createElement('script');
        inlineScript.id = 'gtm-inline-script';
        inlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
        `;
        document.head.appendChild(inlineScript);

        const gtmScript = document.createElement('script');
        gtmScript.id = 'gtm-script';
        gtmScript.async = true;
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
        document.head.appendChild(gtmScript);

        return () => {
            document.getElementById('gtm-inline-script')?.remove();
            document.getElementById('gtm-script')?.remove();
        };
    }, []);

    return null;
};
